export class DailyTimesheetReport {
    date = new Date();
    billable = 0;
    notBillable = 0;
    plannedBillable = 0;
    plannedNotBillable = 0;
    weeklyPlannedBillableSecondsBeforeToday = 0;
    weeklyLoggedBillableSecondsBeforeToday = 0;
    monthlyPlannedBillableSecondsBeforeToday = 0;
    monthlyLoggedBillableSecondsBeforeToday = 0;

    /**
     * @type {TimesheetEntry[]}
     */
    todayEntries = [];

    /**
     * @type {?TimesheetEntry}
     */
    runningEntry = null;

    /**
     * @type {TimesheetEntry[]}
     */
    previousEntriesFromThisWeek = [];

    /**
     * @type {TimesheetEntry[]}
     */
    previousEntriesFromThisMonth = [];

    /**
     * @type {PlannedTime[]}
     */
    todayPlannedEntries = [];

    /**
     * @type {PlannedTime[]}
     */
    previousPlannedTimesFromThisWeek = [];

    /**
     * @type {PlannedTime[]}
     */
    previousPlannedTimesFromThisMonth = [];
}